function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M24.001 4L21.34 6.707A12.03 12.03 0 006.389 8.502L0 15l6.389 6.498c.068.07.141.131.211.198l-2.416 2.457L6 26 25.817 5.846 24.001 4zm-7.344 7.468A3.78 3.78 0 0015 11.083c-2.127 0-3.852 1.754-3.852 3.917 0 .604.139 1.174.379 1.686l-3.11 3.162a3.104 3.104 0 00-.085-.077c-.043-.039-.087-.077-.128-.12L3.631 15l4.574-4.652a9.488 9.488 0 0111.251-1.726l-2.799 2.846zM30 15l-6.389 6.498A12.036 12.036 0 0115 25.12c-1.308 0-2.612-.225-3.865-.65l2.095-2.13a9.5 9.5 0 008.565-2.688L26.369 15l-2.961-3.011 1.815-1.846L30 15z"
})));